import { Box, BoxProps, Text } from '@chakra-ui/react';

export function OutcomeSummaryCard({
  outcomeSummaryList,
  ...boxProps
}: {
  outcomeSummaryList: { title: string; text: string }[];
} & BoxProps) {
  return (
    <Box as='section' backgroundColor='blue.800' borderRadius='8px' height='fit-content' padding='24px' {...boxProps}>
      <Box display='flex' flexDirection='column' gap='24px'>
        {outcomeSummaryList.map((outcomeSummaryItem) => (
          <Box key={outcomeSummaryItem.title}>
            <Text color='accent.sky.500' fontSize='12px' fontWeight='600' textTransform='uppercase'>
              {outcomeSummaryItem.title}
            </Text>

            <Text color='white' fontSize='20px' marginTop='8px'>
              {outcomeSummaryItem.text}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
